// extracted by mini-css-extract-plugin
export default {"srOnly":"a11y_srOnly__5dM0V"};